/* eslint-disable no-unused-expressions */
import { personalization } from "api/cfw";
import { checkDeviceType, getCookie, isEmpty, isMobileSite, isSessionStorageValid, path } from "utils";

export const deviceId = async () => {


    const userAgent = path(['navigator', 'userAgent'], window)?.toLowerCase()
    // const params = window?.location?.href
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
    const ios = /iphone|ipod|ipad/.test(userAgent)
    const safari = /safari/.test(userAgent);
    let deviceType = 'pwa'

    if (
        deviceType === 'iPhoneApp' ||
        window.parent.iosData && window.parent.iosData["app-agent"] ||
        (params?.isMobileApp === 'true' && params?.deviceType === 'ios') || //home page
        (typeof window?.sessionStorage != 'undefined' && sessionStorage?.getItem('mobileApp') === 'iPhoneApp' )||(ios && !safari) || params?.isIosApp === 'true' //deeplink
    ) {
        deviceType = 'iOS'
    } else if (window.parent.androidData && window.parent.androidData["app-agent"]) {
        deviceType = 'Android'
    } else {
        deviceType = 'pwa'
    }
    let req
    const isValidSessionStorage = isSessionStorageValid();
 
    const localStorageDeviceId =  deviceType === "iOS" && isValidSessionStorage? window?.sessionStorage?.getItem("dvid"): window?.localStorage?.getItem("dvid");
    const getDeviceIdCookie = getCookie("ct-dvId") || "";
    const IOS_RETRY_INTERVAL = 500;
    let IOS_COUNT = 1;
    try {
        if (isEmpty(localStorageDeviceId) && isEmpty(getDeviceIdCookie)) {
            if (deviceType === 'iOS') {
                const iosTimer = setInterval(async () => {
                    if (path(["iosData"], window)) {
                   clearInterval(iosTimer);
                   req = await personalization()
                    const { status, headers } = req
                    if (status === 204 || status === '204') {
                        //ios case session storage
                        let iOSDeviceId = window?.parent?.iosData?.['device_id'] || headers['dvid']
                        window?.sessionStorage?.setItem('dvid', iOSDeviceId)
                    }
                 }
                 if (IOS_COUNT >= 20) {
                   clearInterval(iosTimer);
                 }
                 IOS_COUNT += 1;
               }, IOS_RETRY_INTERVAL);
            } else {
                req = await personalization()
                const { status, headers } = req
                if (status === 204 || status === '204') {
                    if (deviceType !== 'pwa') {
                        //mobile check
                        if (deviceType === 'Android') {
                            let androidDeviceId = window?.parent?.androidData['device_id'] || headers['dvid'] //when android dosent give it's deviceId then storage from api
                            window?.localStorage?.setItem('dvid', androidDeviceId)
                        }
                    } else {
                        window?.localStorage?.setItem('dvid', headers['dvid']) // pwa case
                    }
                }
            }
           
        } else if (isEmpty(localStorageDeviceId) && !isEmpty(getDeviceIdCookie) && deviceType === 'pwa') {
                req = await personalization()
                const { status, headers } = req
                if (status === 204) {
                    window?.localStorage?.setItem('dvid', headers['dvid'])
                }
            
        } else if (!isEmpty(localStorageDeviceId) && isEmpty(getDeviceIdCookie)) {
            if(deviceType === 'iOS'){
                const iosTimer = setInterval(async () => {
                    if (path(["iosData"], window)) {
                   clearInterval(iosTimer);
                   req = await personalization(localStorageDeviceId)
                 }
                 if (IOS_COUNT >= 20) {
                   clearInterval(iosTimer);
                 }
                 IOS_COUNT += 1;
               }, IOS_RETRY_INTERVAL);
            }else{
                req = await personalization(localStorageDeviceId)
                  const { status, headers } = req
                if(deviceType === 'Android'){
                if (status === 204 ) {
                    //ios case session storage
                let androidDeviceId = window?.parent?.androidData['device_id'] || headers['dvid'] //when android dosent give it's deviceId then storage from api
                window?.localStorage?.setItem('dvid', androidDeviceId)
                }
            }
            }
        }
    } catch (e) {
        console.error(e);
    }
};
